module.exports = __webpack_public_path__ + "static/img/sp6.6305ab9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sp6.jpg
// module id = nvNN
// module chunks = 0